import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ThumbaCoin } from "@roman/shared/components/Icons";

type referralSuccessModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  earnedPoints: number;
};

export const ReferralSuccessModal = ({ open, setOpen, earnedPoints }: referralSuccessModalProps) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="[&>button]:hidden py-8 w-[350px] md:w-[450px] h-[383px] ring-0 ring-transparent">
        <DialogTitle className="dialog-content text-black text-center font-Inter text-xl font-semibold leading-[30px] max-w-[287px] mx-auto">
          <p>ポイントが獲得されました！</p>
        </DialogTitle>

        <div className="flex justify-center items-center gap-1 bg-gray rounded-full text-black text-lg w-fit mx-auto px-4 py-[5px] font-bold leading-[18px]">
          <ThumbaCoin className="h-6 w-6 space-x-2" />
          <span className="align-middle leading-[18px]">{earnedPoints}pt</span>
        </div>
        <div className="text-dark-gray text-center text-base font-bold">
          <span>運営からの通知からポイント獲得履歴が確認できます</span>
        </div>

        <div className="flex flex-col w-full items-center justify-center mt-2">
          <Button
            className="text-lg w-full py-[25px] text-white rounded-lg font-bold"
            variant="default"
            onClick={() => {
              setOpen(false);
            }}
          >
            確認
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
